// extracted by mini-css-extract-plugin
export var modal = "_cr-0";